var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundStripes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 969,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E6EAF1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.782 162L-193 807h163.256L294 162H131.782zM416.46 0L92 644h163.266L578 0H416.46zM457.345 323L133 969h163.036L619 323H457.345z"
  }))));
}
export default SvgBackgroundStripes;